import { connect } from 'react-redux'
import Settings from './component'
import {
    getGeneralText,
    getResetText,
    getLaunchOptionsText,
    getLayoutText,
    clearCounter,
} from '../../data'
import { selectors as importedSelectors } from '../../imports'

function mapStateToProps(state) {
    return {
        headers: {
            general: getGeneralText(state),
            reset: getResetText(state),
            launchOptions: getLaunchOptionsText(state),
            layout: getLayoutText(state),
        },
        hideLanguagePicker: importedSelectors.getLocale(state) === 'zh',
    }
}

function mapDispatchToProps(dispatch) {
    return {
        clearCounter: () => {
            dispatch(clearCounter())
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Settings)



// WEBPACK FOOTER //
// ./src/features/Settings/components/Settings/index.js